export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/miguel-perales-eb485e1065259ad54239227b5231511a.jpg";